import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'displayValue'
})
export class ExamNameDisplayPipe implements PipeTransform {

  transform(
    item: any,
    key1: string,
    key2?: string,
    separator: string = ' - '
  ): string {

    if (!item || !key1) return '';

    const value1 = item[key1];
    const value2 = key2 ? item[key2] : '';

    if (value1 && value2) {
      return `${value1}${separator}${value2}`;
    }

    return value1 ?? '';
  }

}
